import { create } from 'zustand'

interface PortfolioHoverState {
  hovered: string | null
  setHovered: (v: string | null) => void
}

export const usePortfolioHoverStore = create<PortfolioHoverState>((set) => ({
  hovered: null,
  setHovered: (v) => set({ hovered: v }),
}))
